document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href="#impostazione-cookie"]');
  if (!link) return;

  e.preventDefault();

  if (
    window.privacyBanner &&
    typeof window.privacyBanner.showPreferences === 'function'
  ) {
    window.privacyBanner.showPreferences();
  } else {
    console.warn('privacyBanner non disponibile');
  }
});